import { isEmpty, orderBy } from 'lodash';
import { WidgetState } from '@/modules/ta/widget/widget.constants';
import { getters as storeGetters } from '@/modules/core/app/helpers/store';

export const getters = {
  getLayout(state, layoutId) {
    return state.layouts[layoutId];
  },
  getLayoutsFromIds(state, layoutIds = [storeGetters.dashboard.getCurrentLayoutId()]) {
    if (isEmpty(state.layouts)) {
      return [];
    }
    return layoutIds.map((layoutId) => state.layouts[layoutId]);
  },
  /**
   * @param state
   * @param layoutId
   * @returns {Array<Widget>}
   */
  getWidgetsInLayout(state, layoutId) {
    const widgets = state.layouts[layoutId]?.widgets;
    if (widgets) {
      const widgetIds = Object.keys(widgets);
      return storeGetters.widget.getWidgetsFromIds(widgetIds);
    }

    return [];
  },
  getOrderedWidgetsInLayout(state, layoutId) {
    const widgets = storeGetters.dashboardLayout.getWidgetsInLayout(layoutId);
    return orderBy(widgets, 'display_order');
  },
  getOrderedWidgetsInCurrentLayout() {
    return storeGetters.dashboardLayout.getOrderedWidgetsInLayout(
      storeGetters.dashboard.getCurrentLayoutId()
    );
  },
  /**
   *
   * @param state
   * @param layoutId
   * @returns {boolean}
   */
  areWidgetsInLayoutLoading(state, layoutId) {
    const widgets = state.layouts[layoutId]?.widgets;
    if (widgets) {
      const widgetStores = storeGetters.widget.getWidgetModelsFromIds(Object.keys(widgets));
      return !!widgetStores?.some((widget) => widget.state === WidgetState.STATE_LOADING);
    }
    return false;
  },
  /**
   * @param state
   * @param layoutId
   * @returns {*}
   */
  getDrawOptions(state, layoutId = storeGetters.dashboard.getCurrentLayoutId()) {
    return state.layouts[layoutId]?.metadata?.draw_options;
  },
  getDataSourceWidgetsInAllLayouts(state, dataSourceId, dataViewId) {
    const widgetIds = [];
    Object.keys(state.layouts ?? {}).forEach((layoutId) => {
      const widgets = storeGetters.dashboardLayout.getWidgetsInLayout(layoutId);
      widgets?.forEach((widget) => {
        if (
          widget?.metadata?.data_source?.id === dataSourceId &&
          widget?.data_view_id === dataViewId
        ) {
          widgetIds.push(widget.id);
        }
      });
    });
    return widgetIds;
  },
  getViewingLayoutPreview(state) {
    return state.viewingLayoutPreview;
  },
};
